(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-native-product"]) return;
  try {
    
function initializeNativePawProduct(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const variants = JSON.parse(root.querySelector('[data-native-variants]').textContent);
  const radios = [...root.querySelectorAll('[data-native-option]')];
  const image = root.querySelector('.pb-native-main-image');
  function showImage(src, alt) {
    if (!image || !src) return;
    image.removeAttribute('srcset'); image.src = src;
    if (alt) image.alt = alt;
    root.querySelectorAll('[data-photo]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.photo === src)));
  }
  root.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => showImage(button.dataset.photo, button.dataset.alt)));
  function refresh(updateUrl) {
    const selected = [...new Set(radios.map(r => r.dataset.nativeOption))].map(position => radios.find(r => r.dataset.nativeOption === position && r.checked)?.value);
    const variant = radios.length ? variants.find(v => v.options.every((value, i) => value === selected[i])) : variants[0];
    radios.forEach(r => {
      const index = Number(r.dataset.nativeOption) - 1;
      const matches = variants.filter(v => v.options[index] === r.value && v.options.every((value, i) => i === index || value === selected[i]));
      r.closest('label').classList.toggle('pb-option-sold-out', !matches.some(v => v.available));
    });
    const available = Boolean(variant?.available);
    root.querySelector('[data-native-add]').disabled = !available;
    root.querySelector('[data-native-buy]').disabled = !available;
    root.querySelector('[data-native-add]').textContent = available ? root.dataset.add : root.dataset.sold;
    root.querySelector('[data-native-stock]').textContent = variant ? (available ? root.dataset.stock : root.dataset.sold) : root.dataset.unavailable;
    root.querySelector('[data-native-id]').value = variant?.id || '';
    if (!variant) {
      if (updateUrl) {
        const colourIndex = Number(root.dataset.colourIndex ?? -1);
        const colourVariant = colourIndex >= 0 ? variants.find(v => v.options[colourIndex] === selected[colourIndex] && v.image) : null;
        if (colourVariant) showImage(colourVariant.image);
      }
      return;
    }
    root.querySelector('[data-native-price]').textContent = variant.price;
    root.querySelectorAll('[data-colour-link]').forEach(link => {
      const colourVariants = JSON.parse(link.dataset.colourVariants);
      const match = colourVariants.find(candidate => candidate.options[0] === variant.options[0]);
      if (match) { const colourUrl = new URL(link.href); colourUrl.searchParams.set('variant', match.id); link.href = colourUrl.toString(); }
    });
    const quantity = root.querySelector('[name=quantity]');
    quantity.min = variant.min; quantity.step = variant.increment;
    if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
    if (Number(quantity.value) < variant.min) quantity.value = variant.min;
    if (updateUrl) {
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
      showImage(variant.image);
    }
  }
  radios.forEach(r => r.addEventListener('change', () => refresh(true)));
  refresh(false);
}
document.querySelectorAll('[data-native-product]').forEach(initializeNativePawProduct);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-native-product]').forEach(initializeNativePawProduct));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-product-detail"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){if(!event.target.matches('[data-pb-variant]'))return;const section=event.target.closest('.pb-detail');const display=section.querySelector('[data-pb-price]');const amount=Number(event.target.value);if(Number.isFinite(amount))display.textContent='RM'+amount.toFixed(2)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-product-options"] && !Shopify.designMode) return;
  try {
    
function pawInitializeOptions(section) {
  const picker = section.querySelector('[data-pb-options]');
  if (!picker || picker.dataset.ready) return;
  picker.dataset.ready = 'true';
  const variants = JSON.parse(picker.querySelector('[data-pb-variants]').textContent);
  const inputs = [...picker.querySelectorAll('[data-pb-option]')];
  function refresh(changed) {
    let color = inputs.find(input => input.dataset.pbOption === 'color' && input.checked)?.value || '';
    let size = inputs.find(input => input.dataset.pbOption === 'size' && input.checked)?.value || '';
    let variant = variants.find(item => item.color === color && item.size === size);
    if (!variant && changed === 'color') {
      variant = variants.find(item => item.color === color);
      if (variant) { size = variant.size; inputs.forEach(input => { if (input.dataset.pbOption === 'size') input.checked = input.value === size; }); }
    }
    inputs.filter(input => input.dataset.pbOption === 'size').forEach(input => {
      const matching = variants.filter(item => item.color === color && item.size === input.value);
      input.disabled = matching.length === 0;
      input.closest('label').classList.toggle('pb-option-sold-out', matching.length > 0 && matching.every(item => !item.inStock));
    });
    section.querySelectorAll('[data-pb-purchase]').forEach(button => { button.disabled = !variant || !variant.inStock; });
    const addButton = section.querySelector('.pb-add-to-cart');
    if (addButton) addButton.textContent = variant && variant.inStock ? picker.dataset.addToCart : picker.dataset.soldOut;
    if (!variant) return;
    section.querySelector('[data-pb-price]').textContent = 'RM' + Number(variant.price).toFixed(2);
    picker.querySelector('[data-pb-selection]').textContent = [variant.color, variant.size].filter(Boolean).join(' / ');
    picker.querySelector('[data-pb-stock]').textContent = variant.inStock ? picker.dataset.inStock : picker.dataset.outOfStock;
    picker.querySelector('[data-pb-selected-variant]').value = variant.id;
    const cartVariant = section.querySelector('[data-pb-cart-variant]');
    if (cartVariant) { cartVariant.value = variant.id; cartVariant.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  picker.addEventListener('change', event => { if (event.target.matches('[data-pb-option]')) refresh(event.target.dataset.pbOption); });
  refresh();
}
document.querySelectorAll('.pb-detail--options').forEach(pawInitializeOptions);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.pb-detail--options').forEach(pawInitializeOptions));

  } catch(e) { console.error(e); }
})();
})();
